<template>
  <div class="floor-fontainer">
    <div class="rightgood-body">
      <div 
        class="floor" 
        :class="'floor'+index" 
        :id="'floor'+index" 
        v-for="(item, index) in prodClasses" 
        :key="index"
      >
        <div class="floor-title">
          <h3><a :href="`/product?hktId=${item.hktId}`" target="_blank">{{item.hktName}}</a></h3>
          <a :href="`/product?hktId=${item.hktId}`" target="_blank" class="more">查看全部 &gt;</a>
        </div>
        <div class="floornr">
          <div class="itemsale">
            <a :href="`/product?hktId=${item.hktId}`" target="_blank" class="picbox">
              <img :src="item.hktIcon" :alt="item.hktName">
            </a>
            <a :href="`/product?hktId=${item.hktId}`" target="_blank" class="itemtitle">
              <h4 class="ellipsis">{{item.hktName}}</h4>
              <p class="ellipsis">{{item.hktDesc}}</p>
            </a>
          </div>
          <div class="style-sale">
            <ul>
              <li v-for="(product, pindex) in item.products" :key="pindex">
                <a @click="$emit('jumpToProductDetail', product.productId)">
                  <h4 class="ellipsis">{{product.prodName}}</h4>
                  <p class="ellipsis"></p>
                  <div class="picbox">
                    <img :src="product.coverPhoto" :alt="product.prodName">
                  </div>
                </a>
              </li>
              <img 
                v-if="!item.products || item.products.length === 0" 
                src="/img/no-products.jpg" 
                style="width: 600px; display: block; margin: auto; margin-top: 76px;"
              >
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    prodClasses: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.floor-fontainer {
  width: 100%;
  margin-top: 20px;
}

.floor {
  margin-bottom: 30px;
}

.floor-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.floor-title h3 {
  margin: 0;
  font-size: 18px;
}

.more {
  color: #999;
  text-decoration: none;
}

.floornr {
  display: flex;
  margin-top: 15px;
}

.itemsale {
  width: 200px;
  margin-right: 20px;
}

.picbox {
  display: block;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.picbox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.itemtitle {
  display: block;
  margin-top: 10px;
  color: #333;
  text-decoration: none;
}

.itemtitle h4 {
  margin: 0;
  font-size: 16px;
}

.itemtitle p {
  margin: 5px 0 0;
  color: #999;
  font-size: 12px;
}

.style-sale {
  flex: 1;
}

.style-sale ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 -10px;
  list-style: none;
}

.style-sale ul li {
  width: 25%;
  padding: 0 10px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.style-sale ul li a {
  display: block;
  color: #333;
  text-decoration: none;
}

.style-sale ul li .picbox {
  height: 150px;
  margin-top: 10px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>